module.exports = __webpack_public_path__ + "img/Arrow-up.4f3aa450.svg";